module.exports = __webpack_public_path__ + "static/flags/SB-b4be3dca2ba1626f1eb5531510fd39a1.gif";